import { IList, IRecord } from 'annotation-tools/utils';
import { RawRectangleType } from '../common/raw-rectangle';
import {
  APIRawValidationErrorType,
  APIValidationErrorType,
  IAPIValidationErrorType
} from '../common/validation-error';
import {
  AnnotationAPIRawRequestBodyType,
  AnnotationAPIRequestBodyType,
  CreateAnnotationAPIRawRequestBodyType,
  CreateAnnotationAPIRequestBodyType
} from './api-request-body';

export type AnnotationAPIRawSuccessResponseType = {
  uid: string;
  label: number;
  rectangle: RawRectangleType;
};

export type AnnotationAPIRawValidationErrorType = APIRawValidationErrorType<
  AnnotationAPIRawRequestBodyType
>;

export type AnnotationAPIValidationErrorType = APIValidationErrorType<
  AnnotationAPIRequestBodyType
>;

export type IAnnotationAPIValidationErrorType = IAPIValidationErrorType<
  AnnotationAPIRequestBodyType
>;

export const IAnnotationAPIValidationErrorFactory = IRecord<
  AnnotationAPIValidationErrorType
>({
  labelId: IList<string>(),
  rect: IList<string>()
});

// for create api

export type CreateAnnotationAPIRawValidationErrorType = APIRawValidationErrorType<
  CreateAnnotationAPIRawRequestBodyType
>;

export type CreateAnnotationAPIValidationErrorType = APIValidationErrorType<
  CreateAnnotationAPIRequestBodyType
>;

export type ICreateAnnotationAPIValidationErrorType = IAPIValidationErrorType<
  CreateAnnotationAPIRequestBodyType
>;

export const ICreateAnnotationAPIValidationErrorFactory = IRecord<
  CreateAnnotationAPIValidationErrorType
>({
  uuid: IList<string>(),
  labelId: IList<string>(),
  rect: IList<string>()
});
